export const environment = {
  production: true,
  connection: {
    name: 'LH Sankt Michael Softline (Test)',
    host: 'https://softline-test.lagerhaus-stmichael.at/',
    port: 443,
    basePath: '/api'
  },
  androidUpdateRepository: ''
};
